const LETRAS_NIF = 'TRWAGMYFPDXBNJZSQVHLCKE';
const TIPOS_CIF = 'ABCDEFGHJNPQRSUVW';

export const normalizarIdentificacionFiscal = (identificacion) =>
  String(identificacion || '').toUpperCase().replace(/[\s.-]+/g, '');

export const validarIdentificacionFiscal = (valor) => {
  const identificacion = normalizarIdentificacionFiscal(valor);

  if (/^[0-9]{8}[A-Z]$/.test(identificacion)) {
    return identificacion[8] === LETRAS_NIF[Number(identificacion.slice(0, 8)) % 23];
  }

  if (/^[XYZ][0-9]{7}[A-Z]$/.test(identificacion)) {
    const prefijo = { X: '0', Y: '1', Z: '2' }[identificacion[0]];
    const numero = Number(`${prefijo}${identificacion.slice(1, 8)}`);
    return identificacion[8] === LETRAS_NIF[numero % 23];
  }

  if (/^[KLM][0-9]{7}[A-Z]$/.test(identificacion)) {
    return identificacion[8] === LETRAS_NIF[Number(identificacion.slice(1, 8)) % 23];
  }

  if (!new RegExp(`^[${TIPOS_CIF}][0-9]{7}[0-9A-J]$`).test(identificacion)) {
    return false;
  }

  let suma = 0;
  for (let indice = 0; indice < 7; indice += 1) {
    const digito = Number(identificacion[indice + 1]);
    if (indice % 2 === 0) {
      const doblado = digito * 2;
      suma += Math.floor(doblado / 10) + (doblado % 10);
    } else {
      suma += digito;
    }
  }

  const control = (10 - (suma % 10)) % 10;
  const controlNumerico = String(control);
  const controlAlfabetico = 'JABCDEFGHI'[control];
  const tipo = identificacion[0];
  const controlNumericoObligatorio = 'ABEH'.includes(tipo);
  const controlAlfabeticoObligatorio = 'KNPQSW'.includes(tipo);
  const controlIntroducido = identificacion[8];

  if (controlNumericoObligatorio) {
    return controlIntroducido === controlNumerico;
  }
  if (controlAlfabeticoObligatorio) {
    return controlIntroducido === controlAlfabetico;
  }
  return controlIntroducido === controlNumerico || controlIntroducido === controlAlfabetico;
};
